
<div>
<b-card no-body>
  <b-card-header header-bg-variant="secondary" header-text-variant="light">Summary</b-card-header>
  <b-list-group :style="list_style">
    <b-list-group-item v-for="node in summary_nodes" :key="node.id"
                       class="px-3 py-1 d-flex justify-content-between">
      <span>{{node.name}}</span>
      <span>
          <b-badge v-if="getNodePrice(node) !== 0">{{formatCurrency(getNodePrice(node))}}</b-badge>
        </span>
    </b-list-group-item>
  </b-list-group>
<slot name="footer" v-bind:data="{part_number:part_number,calculated_total_price:calculated_total_price}">
  <b-card-footer footer-bg-variant="light" class="pt-1 pb-1">
    <b-form-group label="SKU" label-cols="4" label-align="right" label-class="text-danger font-weight-bold" class="mb-0"><span class="form-control-plaintext font-weight-bold">{{part_number}}</span></b-form-group>
    <b-form-group label="Total" label-cols="4" label-align="right" label-class="text-danger font-weight-bold" class="mb-0"><span class="form-control-plaintext font-weight-bold">{{formatCurrency(calculated_total_price)}}</span></b-form-group>
    <b-form-group v-if="debugEnabled && debug_message" label="Debug" label-cols="4" label-align="right" label-class="text-danger font-weight-bold" class="mb-0"><span class="form-control-plaintext font-weight-bold">{{debug_message}}</span></b-form-group>
  </b-card-footer>
</slot>
</b-card>
<slot name="after_footer" v-bind:data="{part_number:part_number,calculated_total_price:calculated_total_price}">
</slot>
</div>
